import React from "react";

const LegalAttributes = () => {
  return (
    <div className="flex-1 flex-col h-fit w-full  radius-10 back-white  align-left justify-start  pt-3 pb-2 pl-3 pr-3 g-2">
      <div className="w-full flex-col align-left justify-start g-1">
        <h3 className="t-16 color-grayColor poppins-medium weight-500">
          Legal attribute
        </h3>
        <hr color="#e5e5e5" className="w-full" />
      </div>

      <div className="flex-1 w-full flex-col align-center justify-center color-grayBorder t-18 poppins">
        Under Progress
      </div>
    </div>
  );
};

export default LegalAttributes;
